import { render, staticRenderFns } from "./createPartner.vue?vue&type=template&id=04647b2d&scoped=true&"
import script from "./createPartner.vue?vue&type=script&lang=js&"
export * from "./createPartner.vue?vue&type=script&lang=js&"
import style0 from "./createPartner.vue?vue&type=style&index=0&id=04647b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04647b2d",
  null
  
)

export default component.exports